/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_New_Parent_NameInputs */

const vi_sidebar_layout_new_parent_name = /** @type {(inputs: Sidebar_Layout_New_Parent_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu mới`)
};

/**

* @param {Sidebar_Layout_New_Parent_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_new_parent_name = /** @type {((inputs?: Sidebar_Layout_New_Parent_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_New_Parent_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_new_parent_name(inputs)
});